import './App.css';
import Home from './components/Home';
import { Route, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom';
import ProjectPage from './components/ProjectPage';
import ScrollToTop from './components/ScrollToTop';
import { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import Loader from './components/Loader';

function App() {
  const [view, setView] = useState( '' )
  const cursor = useRef( null )
  const [loading, setLoading] = useState( true );

  useEffect( () => {
    loading
      ? document.querySelector( "body" ).classList.add( "loading" )
      : document.querySelector( "body" ).classList.remove( "loading" );
  }, [loading] );

  const changePosition = ( e ) => {
    if ( view === 'web' ) {
      cursor.current.style.top = `${e.clientY}px`;
      cursor.current.style.left = `${e.clientX}px`;
    }
  }

  useEffect( () => {
    if ( window.innerWidth < 769 ) {
      setView( 'mobile' )
    }
    else {
      setView( 'web' )
    }
  }, [] )

  return (
    <AnimatePresence>
      { loading ? (
        <motion.div key='loader'>
          <Loader setLoading={ setLoading } />
        </motion.div>
      ) : (
          view.length > 0 &&
          <div className="App" style={ { cursor: `${view === 'web' ? 'none' : 'unsets'}` } } onMouseMove={ changePosition }>
            { view === 'web' && <>
                <div className="cursor-style" ref={ cursor } ></div>
              <div className="cursor-style-outer"  ></div>
            </> }
            <Router>
              <ScrollToTop />
              <Routes>
                <Route exact path="/" element={ <Home view={ view } /> } />
                <Route path="/:projectId" element={ <ProjectPage /> } />
                <Route
                  path="*"
                  element={ <Navigate to="/" replace /> }
                />
              </Routes>
            </Router>
          </div>
      ) }
    </AnimatePresence>
  );
}

export default App;
